import { render } from "./PublicContact.vue?vue&type=template&id=dafad2b6"
import script from "./PublicContact.vue?vue&type=script&lang=js"
export * from "./PublicContact.vue?vue&type=script&lang=js"

import "./PublicContact.vue?vue&type=style&index=0&id=dafad2b6&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__